<template>
  <article>
    <div class="fan-detail">
      <cell>
        <span slot="icon" class="fan-icon-love"><img src="../../stylesheets/images/fan-icon.png"/></span>
        <div slot="after-title" class="fan-title">关注粉丝数<div class="fan-count">{{total.total_fans}}</div></div>
        <div slot="child" class="fan-title">新增<div class="fan-update-count">{{total.subscribed}}</div></div>
        <div slot="child" class="fan-title fan-title-margin">取消<div class="fan-update-count">{{total.unsubscribed}}</div></div>
      </cell>
    </div>
    <div class="fan-detail fan-detail-top-line">
      <cell>
        <span slot="icon" class="fan-icon-phone"><img src="../../stylesheets/images/phone-icon.png"/></span>
        <div slot="after-title" class="fan-title">手机绑定数<div class="fan-count">{{total.total_boud}}</div></div>
        <div slot="child" class="fan-title">新增<div class="fan-update-count">{{total.bound}}</div></div>
        <div slot="child" class="fan-title fan-title-margin">解绑<div class="fan-update-count">{{total.unbound | transferToInt}}</div></div>
      </cell>
    </div>
  </article>
</template>
<script>
import {
  Cell
} from '@lx-frontend/cvux'
export default {
  components: {
    Cell
  },
  props: {
    total: Object
  },
  filters: {
    transferToInt(num) {
      if (!num) return 0
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less">
@import "../../stylesheets/modules/data/carData.less";
</style>
